import React from 'react'
import PropTypes from 'prop-types'

import StatusIndicator from './StatusIndicator'
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import CloudOffIcon from '@material-ui/icons/CloudOff';

import { red, yellow } from '@material-ui/core/colors';

const NetworkIndicator = ({ available, speed, className, ...props }) => {
  var icon = <CloudDoneIcon style={{color: "white"}} />
  var networkSignal = "Online"

  if (!available) {
    icon = <CloudOffIcon style={{ color: red[400] }} />
    networkSignal= "Offline"
  } else if (speed === 1) {
    icon = <CloudQueueIcon style={{ color: yellow[100] }} />
    networkSignal= "Weak"
  } else if (speed === 2) {
    icon = <CloudQueueIcon style={{ color: yellow[100] }} />
    networkSignal = "Weak"
  } else if (speed === 3) {
    icon = <CloudDoneIcon style={{ color: "white" }} />
    networkSignal = "Online"
  } 

  return <StatusIndicator {...props} icon={icon} text={networkSignal} showClock={true} />

}

NetworkIndicator.defaultProps = {
  available: false,
  text: "network"
}

NetworkIndicator.propTypes = {
  available: PropTypes.bool,
  text: PropTypes.string
}

export default NetworkIndicator
